import { listSidebarPortalClass } from './const';

export function hasNew2Sidebar() {
	return document.querySelector(`.${listSidebarPortalClass}`) !== null;
}

export const getPortalContainer = () => {
	return document.querySelector<HTMLDivElement>('.listPageHeaderFilterButton');
};
